import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Lane/Lane.requests'
import {
    AccountLane,
} from '../AccountLanes.types'

const useGetAccountLane = (id: number) => {
    return useRequest<AccountLane>({
        key: RequestKeys.getAccountLane,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.getLaneAccountData),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetAccountLane
